module.exports = __webpack_public_path__ + "0432119a47503ae21ebce9e2141bd805.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/flask-orange-s.png
// module id = 2522
// module chunks = 0